import { lazy, Suspense } from 'react';
import { AppErrorBoundary } from '@/components/app-error-boundary';
import { useAuth } from '@/services/auth';
import { isFlexPlan } from '@/services/auth/plan-slugs';
import { TrialCta } from './trial-cta';

// Load this lazily. The Add funds flow imports the purchase modals and Stripe, and a static import
// adds them to the nav for every account.
const LazyFlexNavCard = lazy(() => import('./flex-nav-card').then((m) => ({ default: m.FlexNavCard })));

/** The nav footer's plan call to action: the Flex card on the Flex plan, the Upgrade button otherwise. */
export function PlanNavCta() {
  const { account } = useAuth();
  if (!isFlexPlan(account)) return <TrialCta />;

  // The nav sits outside the layout's error boundary, so a failed chunk load would replace the whole
  // shell. Losing the card is the better failure.
  return (
    <AppErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <LazyFlexNavCard />
      </Suspense>
    </AppErrorBoundary>
  );
}
